const TaskCard = ({ task, onEditTaskClick, onViewCommentsClick }) => {
  const handleDragStart = (e) => {
    e.dataTransfer.setData("taskId", task.id);
    e.dataTransfer.setData("sourceColumnId", task.columnId);
    e.dataTransfer.effectAllowed = "move";
  };

  // Check if this is a lead (has leadData)
  const isLead = task.leadData;
  const leadData = task.leadData || {};

  // Helper function to get budget color
  const getBudgetColor = (budget) => {
    if (!budget) return "bg-gray-600";
    if (budget.includes("supérieur à 3000 euros")) return "bg-green-600";
    if (budget.includes("1500 euros et 3000 euros")) return "bg-yellow-600";
    if (budget.includes("1000 euros")) return "bg-orange-600";
    return "bg-red-600";
  };

  // Helper function to get situation icon
  const getSituationIcon = (situation) => {
    if (!situation) return "👤";
    if (situation.toLowerCase().includes("étudiant")) return "�";
    if (situation.toLowerCase().includes("salarié")) return "💼";
    if (situation.toLowerCase().includes("entrepreneur")) return "🚀";
    return "👤";
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onClick={() => onEditTaskClick(task)}
      className={`${
        isLead
          ? "bg-gradient-to-br from-blue-900/20 to-purple-900/20 border-blue-500/30"
          : "bg-[#242940]"
      } rounded-lg p-3 shadow-md cursor-grab active:cursor-grabbing border hover:border-blue-500 transition-all duration-200 text-white`}
    >
      <div className="flex justify-between pb-4">
        <div className="flex -space-x-1 overflow-hidden">
          {task?.assignees.length > 0
            ? task?.assignees.slice(0, 4).map((assignee, index) => (
                <img
                  key={index}
                  className="inline-block h-7 w-7 rounded-full ring-2 ring-gray-700 object-cover"
                  src={`https://placehold.co/28x28/4a90e2/ffffff?text=${assignee
                    .charAt(0)
                    .toUpperCase()}`}
                  alt={assignee}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `https://placehold.co/28x28/4a90e2/ffffff?text=${assignee
                      .charAt(0)
                      .toUpperCase()}`;
                  }}
                />
              ))
            : "No assignees"}
          {task.assignees.length > 4 && (
            <div className="h-7 w-7 rounded-full bg-gray-500 flex items-center justify-center text-white text-xs font-bold ring-2 ring-gray-700">
              +{task.assignees.length - 4}
            </div>
          )}
        </div>
        <div className="flex items-center space-x-3 text-gray-400 text-sm">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onViewCommentsClick(task);
            }}
            className="flex items-center hover:text-blue-400 transition-colors duration-200 p-1 rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.244-.906C3.793 17.553 2 21 2 21c.335-.873 1.267-2.738 2.37-4.301C3.627 15.147 3 13.513 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <span>{task.commentCount || 0}</span>
          </button>
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              />
            </svg>
            <span>{task.attachmentCount || 0}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        {/* Task Title - adjusted for leads */}
        <h4 className="text-white text-start text-lg font-semibold mb-1">
          {isLead ? `${leadData.name || "Lead"}` : task.title}
        </h4>
        <div className="flex flex-col space-y-1">
          <div className="flex items-center space-x-2 text-xs text-gray-400">
            {leadData.email && (
              <span className="flex items-center">
                📧{" "}
                {leadData.email.length > 20
                  ? leadData.email.substring(0, 20) + "..."
                  : leadData.email}
              </span>
            )}
          </div>
          <div className="flex items-center space-x-2 text-xs text-gray-400">
            {leadData.phone && (
              <div className="text-xs text-gray-400">📱 {leadData.phone}</div>
            )}
          </div>
          <div className="flex items-center space-x-2 text-xs text-gray-400">
            {leadData.currentSituation && <div className="text-xs text-gray-400">👤 {leadData.currentSituation}</div>}
          </div>
          <div className="flex text-start items-center space-x-2 text-xs text-gray-400">
            {leadData.motivation && <div className="text-xs text-gray-400">🎯{leadData.motivation}</div>}
          </div>
         
        </div>
      </div>

      <div className="flex justify-between items-center mt-4">
        {task.source && (
          <div className="flex flex-wrap gap-1">
              <span
                className={`text-xs px-2 py-1 rounded-full font-medium `}
              >
                {task.source}
              </span>
          </div>
        )}

        <button className="text-gray-400 hover:text-white p-1 rounded-full hover:bg-gray-700 transition-colors ml-auto">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TaskCard;
